<template>
  <v-container>
    <h1 class="display-1 pt-3">
      Classroom Settings
    </h1>
    <v-row row wrap>
      <!-- Course Details -->
      <v-col class="my-2 col-12 col-sm-12 col-md-7">
        <v-card class="pa-4" outlined height="100%">
          <v-card-title class="pa-0 ma-0">Details</v-card-title>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="true"
              v-model="name"
              :rules="nameRules"
              label="Name"
              clearable
            ></v-text-field>
          </v-form>
        </v-card>
      </v-col>
      <!-- Logo Handling -->
      <v-col class="my-2 col-12 col-sm-12 col-md-5">
        <v-card class="pa-4" outlined height="100%">
          <div class="d-flex">
            <v-card-title class="pa-0 ma-0">Classroom Logo</v-card-title>
            <v-spacer />
            <v-btn
              depressed
              color="blue white--text ml-auto"
              @click="pickimage = true"
            >
              <v-icon left dark>mdi-image</v-icon>
              Browse
            </v-btn>
          </div>
          <v-card-subtitle class="ma-0 pa-0 pt-3"
            >The classroom icon is used for larger screen displays such as the
            navigation bar, and signup / signin pages.
          </v-card-subtitle>
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="col-12 justify-center align-center">
                <v-img
                  :src="icon"
                  max-height="250"
                  width="100%"
                  contain
                  position="center"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col class="my-2 col-12 col-sm-12 col-md-7">
        <v-card class="pa-4" outlined height="100%">
          <div class="d-flex">
            <v-card-title class="pa-0 ma-0">Classroom Favicon</v-card-title>
            <v-spacer />
            <v-btn
              depressed
              color="blue white--text ml-auto"
              @click="pickimagefavicon = true"
            >
              <v-icon left dark>mdi-image</v-icon>
              Browse
            </v-btn>
          </div>
          <v-card-subtitle class="ma-0 pa-0"
            >This will be the default image sent at the top of every
            message.</v-card-subtitle
          >
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="col-12 justify-center align-center">
                <v-img
                  :src="favicon"
                  max-height="250"
                  width="100%"
                  contain
                  position="center"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-scroll-x-reverse-transition>
      <v-btn
        fab
        :disabled="!isValid"
        normal
        color="green"
        :fixed="true"
        bottom
        right
        v-show="edited"
        class="white--text"
        @click="saveSettings"
      >
        <v-icon>mdi-content-save-outline</v-icon>
      </v-btn>
    </v-scroll-x-reverse-transition>
    <a-imagemodal
      :dialog="pickimage"
      @close="pickimage = false"
      @finish="onIconPick"
    />
    <a-imagemodal
      :dialog="pickimagefavicon"
      @close="pickimagefavicon = false"
      @finish="onFaviconPick"
    />
  </v-container>
</template>

<script>
import images from "@/components/imagedisplay-modal";
import services from "@/services/index.js";
export default {
  components: {
    "a-imagemodal": images
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      pickimage: false,
      pickimagefavicon: false,
      edited: false,
      show: false,
      icon: "",
      favicon: "",
      name: "",
      nameRules: [v => !!v || "Name is required"]
    };
  },
  computed: {
    isValid() {
      return this.valid && this.icon != "";
    }
  },
  watch: {
    name(val, past) {
      if (this.isLoading || past == "") {
        return;
      }
      this.edited = true;
    },
    icon(val, past) {
      if (this.isLoading || past == "") {
        return;
      }
      this.edited = true;
    },
    favicon(val, past) {
      if (this.isLoading || past == "") {
        return;
      }
      this.edited = true;
    }
  },
  methods: {
    async saveSettings() {
      try {
        this.$store.commit("setLoading", true);
        await services.organization.update({
          id: this.$store.getters["getOrganization"]._id,
          name: this.name,
          icon: this.icon,
          favicon: this.favicon
        });
        this.edited = false;
        let updated = {
          ...this.$store.getters["getOrganization"],
          icon: this.icon,
          name: this.name,
          favicon: this.favicon
        };
        this.$store.commit("setOrganization", updated);
      } catch (err) {
        //TODO - Add failed to save icon....
        console.log(err);
      }
      this.$store.commit("setLoading", false);
    },
    onFaviconPick(image) {
      console.log("image", image);
      this.pickimagefavicon = false;
      this.favicon = image.Location;
    },
    onIconPick(image) {
      console.log("image", image);
      this.pickimage = false;
      this.icon = image.Location;
    }
  },
  mounted() {
    this.$store.commit("setLoading", true);
    this.isLoading = true;
    console.log("Settings Mounted");
    let organization = this.$store.getters["getOrganization"];
    this.icon = organization.icon;
    this.favicon = organization.favicon;
    this.name = organization.name;
    this.isLoading = false;
    this.$store.commit("setLoading", false);
  }
};
</script>
